import { Sparkles, Smile, Frown, Baby, Zap, Wrench, Droplet, ShieldAlert } from "lucide-react";

export const helpConcerns = [
  {
    icon: "missing",
    title: "I have missing teeth",
    tag: "Restore",
    problem: "Gaps, difficulty chewing, self‑conscious smile",
    solutions: ["Dental Implants", "Fixed Bridges", "All‑on‑4 / All‑on‑6", "Removable Dentures"],
    lead: "Permanent, natural‑looking replacements that let you eat, laugh and speak with full confidence.",
  },
  {
    icon: "crooked",
    title: "My teeth are crooked or crowded",
    tag: "Align",
    problem: "Misaligned bite, crowding, gaps",
    solutions: ["Invisalign (Clear Aligners)", "Ceramic Braces", "Metal Braces", "Retainers"],
    lead: "Straighten your smile at any age with barely‑visible aligners or modern low‑friction braces.",
  },
  {
    icon: "stained",
    title: "My teeth look dull or stained",
    tag: "Brighten",
    problem: "Yellowing, coffee/tobacco stains, dull enamel",
    solutions: ["In‑Clinic Zoom Whitening", "Home Whitening Kits", "Ceramic Veneers", "Composite Bonding"],
    lead: "See visibly whiter teeth in a single 60‑minute session — safe and enamel‑friendly.",
  },
  {
    icon: "pain",
    title: "I have tooth pain or sensitivity",
    tag: "Relieve",
    problem: "Sharp pain, throbbing, cold/hot sensitivity",
    solutions: ["Single‑Sitting Root Canal", "Composite Fillings", "Deep Cleaning", "Desensitisation"],
    lead: "Same‑day, pain‑free root canal using rotary endodontics — save your natural tooth.",
  },
  {
    icon: "gums",
    title: "My gums bleed or feel swollen",
    tag: "Heal",
    problem: "Bleeding gums, bad breath, receding gum line",
    solutions: ["Scaling & Root Planing", "Laser Gum Therapy", "Periodontal Surgery", "Preventive Care"],
    lead: "Advanced periodontal care to stop gum disease before it damages your teeth and jawbone.",
  },
  {
    icon: "broken",
    title: "I chipped or broke a tooth",
    tag: "Repair",
    problem: "Fractured, chipped or worn‑out tooth",
    solutions: ["Zirconia / E‑max Crowns", "Ceramic Veneers", "Composite Bonding", "Onlays / Inlays"],
    lead: "Custom‑crafted crowns and veneers that match your natural tooth colour perfectly.",
  },
  {
    icon: "kids",
    title: "My child needs a dentist",
    tag: "Care",
    problem: "Cavities, thumb‑sucking, early orthodontic issues",
    solutions: ["Kid‑Friendly Cleaning", "Fluoride & Sealants", "Painless Fillings", "Habit Correction"],
    lead: "Gentle, calm, no‑fear dentistry for children in a warm, playful environment.",
  },
  {
    icon: "makeover",
    title: "I want a full smile makeover",
    tag: "Design",
    problem: "Multiple concerns — colour, shape, alignment",
    solutions: ["Digital Smile Design", "Hollywood Veneers", "Full‑Mouth Rehabilitation", "Gum Contouring"],
    lead: "3D preview of your new smile before treatment starts — designed by our prosthodontist.",
  },
];

export const tourismSteps = [
  { step: "01", title: "Connect Before You Travel", desc: "Share your dental concerns, X-rays, reports or photographs on WhatsApp for an initial discussion with our team." },
  { step: "02", title: "Plan Your Visit", desc: "We'll help you understand the likely treatment stages and approximate time you may need to stay in Lucknow." },
  { step: "03", title: "Treatment at the Clinic", desc: "Your treatment plan is finalised after clinical examination and appropriate diagnostic evaluation." },
  { step: "04", title: "Recover & Explore Lucknow", desc: "When your treatment and recovery permit, experience Lucknow's heritage, Chikankari and celebrated Awadhi culture." },
];

export const tourismBenefits = [
  { title: "Value-Focused Dental Care", desc: "Explore quality dental treatment in Lucknow with a personalised estimate based on your treatment needs, materials and case complexity." },
  { title: "Advanced Treatment Planning", desc: "Clinical evaluation and diagnostic imaging such as CBCT are used when indicated to plan treatment according to your individual needs." },
  { title: "English-Speaking Team", desc: "Communicate comfortably with our clinical team before, during and after your visit." },
  { title: "Pre-Visit Coordination", desc: "Share your concerns and available dental records on WhatsApp so we can help you prepare for your visit." },
];

export const awards = [
  { year: "Since 2025", title: "Scientific Chairperson \u2013 Indian Federation of Advance Dentistry (IFAD)", org: "Held by Dr. Jaspreet Singh Khurana" },
  { year: "2025", title: "Best Implantologist of The Year", org: "Indian Society of Periodontology & Implantology" },
  { year: "2024", title: "Best Paper Presentation \u2013 XIII International Congress of AOI", org: "Academy of Oral Implantology (AOI)" },
  { year: "2022", title: "Best E\u2011Poster Presentation \u2013 4th World Dental Sciences & Oral Health Conference", org: "CynoDent, at KGMU Lucknow" },
  { year: "2022", title: "Academic Excellence Award", org: "SPPGI, Lucknow" },
  { year: "Life", title: "Life Member \u2013 Indian Dental Association (IDA)", org: "Professional Membership" },
  { year: "Life", title: "Life Member \u2013 Indian Federation of Advance Dentistry (IFAD)", org: "Professional Membership" },
  { year: "Life", title: "Life Member \u2013 Indian Society of Periodontology (ISP)", org: "Professional Membership" },
  { year: "Life", title: "Life Member \u2013 Academy of Oral Implantology (AOI)", org: "Professional Membership" },
];
